// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3Yn5l","head":"ProcedureTableInfo_head__8YekC"};